import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { shareContent } from '../../utils/shareUtils';
import './InterviewEventPage.css';

const InterviewEventPage = () => {
  const navigate = useNavigate();
  const [shareMessage, setShareMessage] = useState('');

  // 채널톡 열기 함수
  const openChannelTalk = () => {
    // Google Analytics 이벤트 추적
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'interview_apply_click', {
        event_category: 'Events',
        event_label: 'interview_detail_page',
        value: 1
      });
    }

    // 채널톡이 로드되어 있는지 확인
    if (window.ChannelIO) {
      window.ChannelIO('show');
    } else {
      // 채널톡이 없으면 이메일로 안내
      window.location.href = 'mailto:angel@plactical.com?subject=[고객 인터뷰 이벤트] 왓퀴즈 개선 인터뷰 참여';
    }
  };

  const goBack = () => {
    navigate('/events');
  };

  // 이벤트 공유 함수
  const handleShareEvent = async () => {
    const shareData = {
      title: '왓퀴즈 고객 인터뷰 이벤트 - 신세계 상품권 1만원!',
      text: '왓퀴즈 고객 인터뷰에 참여하고 신세계 상품권 1만원을 받아보세요! 교사용 AI 플랫폼',
      url: `${window.location.origin}/events/interview`
    };

    // Google Analytics 이벤트 추적
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'interview_share_click', {
        event_category: 'Events',
        event_label: 'interview_page_share',
        value: 1
      });
    }

    const result = await shareContent(shareData);
    
    if (result.success) {
      setShareMessage('이벤트가 공유되었습니다!');
    } else if (result.error) {
      setShareMessage(result.error.includes('복사') ? 'URL이 복사되었습니다!' : '공유에 실패했습니다.');
    }

    // 메시지 자동 제거
    setTimeout(() => setShareMessage(''), 3000);
  };

  const benefits = [
    {
      title: '신세계 상품권 1만원',
      description: '인터뷰 완료 즉시 지급'
    },
    {
      title: '신기능 우선 체험',
      description: '개발 중인 신기능을 먼저 체험해요'
    },
    {
      title: '직접 소통 기회',
      description: '개발진과 직접 소통하며 서비스 개선에 참여'
    }
  ];

  return (
    <div className="interview-event-page">
      <Helmet>
        <title>고객 인터뷰 이벤트 - 왓퀴즈</title>
        <meta name="description" content="왓퀴즈 개발진과 직접 소통하며 서비스 개선에 참여하고 신세계 상품권 1만원을 받으세요!" />
        <meta property="og:title" content="고객 인터뷰 이벤트 - 왓퀴즈" />
        <meta property="og:description" content="왓퀴즈 개발진과 직접 소통하며 서비스 개선에 참여하고 신세계 상품권 1만원을 받으세요!" />
      </Helmet>

      {/* 헤더 섹션 */}
      <section className="interview-header">
        <div className="container">
          <button className="back-button" onClick={goBack}>
            ← 이벤트 목록
          </button>
          
          <div className="page-title-section">
            <div className="interview-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <h1 className="interview-title">고객 인터뷰</h1>
            <p className="interview-subtitle">30분 화상 인터뷰에 참여하고 상품권을 받으세요</p>
          </div>
        </div>
      </section>

      {/* 혜택 섹션 - Value First */}
      <section className="interview-benefits">
        <div className="container">
          <h2>참여 혜택</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <span className="benefit-num">{index + 1}</span>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 참여 안내 섹션 */}
      <section className="interview-info">
        <div className="container">
          <h2>이렇게 진행돼요</h2>
          <div className="info-steps">
            <div className="info-step">
              <div className="step-num">1</div>
              <div className="step-text">
                <h3>채널톡으로 신청</h3>
                <p>간편하게 신청해주세요</p>
              </div>
            </div>
            <div className="info-step">
              <div className="step-num">2</div>
              <div className="step-text">
                <h3>일정 조율</h3>
                <p>1주일 내 개별 연락드려요</p>
              </div>
            </div>
            <div className="info-step">
              <div className="step-num">3</div>
              <div className="step-text">
                <h3>30분 화상 인터뷰</h3>
                <p>구글 미트 또는 줌으로 진행해요</p>
              </div>
            </div>
            <div className="info-step">
              <div className="step-num">4</div>
              <div className="step-text">
                <h3>즉시 리워드 지급</h3>
                <p>인터뷰 완료 후 바로 지급해요</p>
              </div>
            </div>
          </div>

          <div className="info-note">
            <p>왓퀴즈 사용 경험이 있는 현직 교사라면 누구나 참여할 수 있어요</p>
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="interview-apply">
        <div className="container">
          <div className="apply-content">
            <h2>지금 바로 신청하세요</h2>
            <p>매월 2-3회 진행되는 소중한 기회예요</p>

            <div className="button-group">
              <button className="apply-button" onClick={openChannelTalk}>
                인터뷰 신청하기
              </button>
              
              <button className="share-button" onClick={handleShareEvent}>
                이벤트 공유하기
              </button>
            </div>

            {shareMessage && (
              <div className="share-message">
                {shareMessage}
              </div>
            )}

            <p className="apply-note">
              * 신청 후 1주일 내 일정 조율 연락드립니다
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InterviewEventPage;
